import { useState } from "react";
import { Loader2, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!consent) {
      setError("Devi accettare la privacy policy");
      return;
    }
    setLoading(true);
    try {
      const r = await api.post("/newsletter/subscribe", {
        email: email.trim(),
        consent: true,
        source: "footer",
        lang: "it",
      });
      if (r.data?.status === "already_subscribed") {
        setError("Questa email è già iscritta");
      } else {
        setDone(true);
      }
    } catch (e) {
      setError(e?.response?.data?.detail || "Errore durante l'iscrizione");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        className="rounded-2xl bg-[#1f1f1f] border border-[#b29d7e]/30 p-5 flex items-start gap-3 animate-in fade-in zoom-in-95 duration-500"
        data-testid="newsletter-success"
      >
        <CheckCircle2 className="w-5 h-5 text-[#b29d7e] mt-0.5 flex-shrink-0" />
        <div className="text-sm text-white/80 leading-relaxed">
          <strong className="text-white">Iscrizione completata!</strong>
          <br />
          Riceverai a breve un'email di benvenuto (controlla anche lo spam).
        </div>
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-3"
      data-testid="newsletter-form"
    >
      <div className="flex gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="la-tua@email.it"
          disabled={loading}
          data-testid="newsletter-email-input"
          className="flex-1 bg-[#1a1a1a] border border-white/10 rounded-full px-4 py-2.5 text-sm text-white placeholder-white/40 focus:outline-none focus:border-[#b29d7e] transition-colors disabled:opacity-50"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit-btn"
          className="px-5 py-2.5 bg-[#b29d7e] hover:bg-[#9d8966] text-white rounded-full text-sm font-medium transition-all disabled:opacity-60 active:scale-95"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Iscrivimi"}
        </button>
      </div>
      <label className="flex items-start gap-2 text-xs text-white/75 cursor-pointer">
        <input
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          data-testid="newsletter-consent-checkbox"
          className="mt-0.5 accent-[#b29d7e]"
        />
        <span className="leading-relaxed">
          Acconsento al trattamento dei dati ai sensi della{" "}
          <a href="/privacy-policy" className="text-[#b29d7e] hover:underline">
            privacy policy
          </a>
          . Posso disiscrivermi in qualsiasi momento.
        </span>
      </label>
      {error && (
        <p className="text-xs text-red-400" data-testid="newsletter-error">
          {error}
        </p>
      )}
    </form>
  );
};

export default NewsletterSignup;
